import React from "react";
import { Trans, useTranslation } from "react-i18next";
import type { ModalProps } from "antd/lib";
import { ModalWrapper } from "../ModalWrapper";
import styles from "./styles.module.scss";
import { IcloudMoreIcon, IcloudUploadIcon } from "./Icons";

export const ModalVcfInfo: React.FC<ModalProps> = ({ ...props }) => {
  const { t } = useTranslation();
  return (
    <ModalWrapper
      cancelButtonProps={{ style: { display: "none" } }}
      okText="Ok"
      modalTitle={t("vcfModal.modalTitle")}
      closable
      width={560}
      className={styles.root}
      {...props}
    >
      <div className={styles.content}>
        <div className={styles.section}>
          <div className={styles["section-title"]}>{t("vcfModal.firstSection.title")}</div>
          <div className={styles["section-content"]}>
            <ul className={styles["section-list"]}>
              <li className={styles["section-list-item"]}>
                <Trans
                  i18nKey="vcfModal.firstSection.bullet1"
                  components={{
                    icloud: (
                      <a target="_blank" href="https://www.icloud.com/" rel="noreferrer">
                        icloud.com
                      </a>
                    ),
                    bold: <span className={styles.bold}></span>,
                  }}
                />
              </li>
              <li className={styles["section-list-item"]}>
                <Trans
                  i18nKey="vcfModal.firstSection.bullet2"
                  components={{
                    bold: <span className={styles.bold}></span>,
                    more: (
                      <span className={styles.icon}>
                        <IcloudMoreIcon />
                      </span>
                    ),
                  }}
                />
              </li>
              <li className={styles["section-list-item"]}>
                <Trans
                  i18nKey="vcfModal.firstSection.bullet3"
                  components={{
                    bold: <span className={styles.bold}></span>,
                    upload: (
                      <span className={styles.icon}>
                        <IcloudUploadIcon />
                      </span>
                    ),
                  }}
                />
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles["section-title"]}>{t("vcfModal.secondSection.title")}</div>
          <div className={styles["section-content"]}>
            <ul className={styles["section-list"]}>
              <li className={styles["section-list-item"]}>
                <Trans
                  i18nKey="vcfModal.secondSection.bullet1"
                  components={{
                    bold: <span className={styles.bold}></span>,
                    google: (
                      <a target="_blank" href="https://contacts.google.com/" rel="noreferrer">
                        contacts.google.com
                      </a>
                    ),
                  }}
                />
              </li>
              <li className={styles["section-list-item"]}>
                <Trans
                  i18nKey="vcfModal.secondSection.bullet2"
                  components={{
                    bold: <span className={styles.bold}></span>,
                    google: (
                      <a target="_blank" href="https://contacts.google.com/" rel="noreferrer">
                        Google Contacts
                      </a>
                    ),
                  }}
                />
              </li>
              <li className={styles["section-list-item"]}>
                <Trans
                  i18nKey="vcfModal.secondSection.bullet3"
                  components={{
                    bold: <span className={styles.bold}></span>,
                    br: <br />,
                  }}
                />
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.footer}>{t("vcfModal.footer")}</div>
      </div>
    </ModalWrapper>
  );
};
